import React, { useContext, useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/auth';
import ChangePassword from './ChangePassword';
import usePopup from '../../../../hooks/usePopup';
import CloudFunctionClientContext from '../../../../contexts/CloudFunctionClientContext';
import useOnPasswordChanged from 'screens/AcceptInvite/hooks/useOnPasswordChanged';

const ChangePasswordContainer = () => {
  const { api } = useContext(CloudFunctionClientContext);
  const { isOpen, open, close } = usePopup();
  const [hasWrongPassword, setHasWrongPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPassword, setCurrentPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [newPasswordErrors, setNewPasswordErrors] = useState<
    string[] | undefined
  >();
  const [isHidingPassword, setIsHidingPassword] = useState<boolean>(true);

  const onCurrentPasswordChanged = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setCurrentPassword(event.target.value);
  };

  const onNewPasswordChanged = useOnPasswordChanged({
    setPasswordErrors: setNewPasswordErrors,
    setPassword: setNewPassword,
  });

  const onCancel = () => {
    close();
    setIsLoading(false);
    setHasWrongPassword(false);
  };

  const isValid =
    newPasswordErrors === undefined || newPasswordErrors.length === 0;

  const onSubmit = () => {
    if (!isValid) {
      return;
    }
    setIsLoading(true);
    const { currentUser } = firebase.auth();
    if (!currentUser || !currentUser.email) {
      return;
    }

    const credential = firebase.auth.EmailAuthProvider.credential(
      currentUser.email,
      currentPassword,
    );

    currentUser
      .reauthenticateWithCredential(credential)
      .then(() =>
        currentUser.updatePassword(newPassword).then(() => {
          api
            .post(
              `/v1/auth/reset_password/${currentUser.uid}/send_password_changed_email`,
              {},
            )
            .then(() => {
              alert('Password updated successfully');
              close();
              setIsLoading(false);
            });
        }),
      )
      .catch(({ code }) => {
        if (code === 'auth/wrong-password') {
          setHasWrongPassword(true);
        }
        setIsLoading(false);
      });
  };

  return (
    <ChangePassword
      isOpen={isOpen}
      open={open}
      close={close}
      onSubmit={onSubmit}
      onCancel={onCancel}
      hasWrongPassword={hasWrongPassword}
      isLoading={isLoading}
      currentPassword={currentPassword}
      onCurrentPasswordChanged={onCurrentPasswordChanged}
      newPassword={newPassword}
      onNewPasswordChanged={onNewPasswordChanged}
      newPasswordErrors={newPasswordErrors}
      isHidingPassword={isHidingPassword}
      setIsHidingPassword={setIsHidingPassword}
      isValid={isValid}
    />
  );
};

export default ChangePasswordContainer;
